import { BaseDocument } from '../../../base/BaseDocument';
import { IBaseEntry } from '../../../base/interfaces/IBaseEntry';
import { DecorType } from './decor-type';
import { BaseEntity } from '../../../base/BaseEntity';

export class Decor extends BaseDocument implements IBaseEntry {
    plasardDecorTypeId:string;
    plasardDecorType:DecorType;
    picture:string;
    items:DecorItem[];
    itemsInternalSum:number;
    itemsSum:number;
    itemPrice:number;
}
export class DecorItem extends BaseEntity implements IBaseEntry {    
    decorId:string;
    itemId:string;
    name:string;
    quantity:number;
    price:number;
    priceInternal:number;
    amount:number;
    amountInternal:number;
}
